import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent {

  @Input() displayDialog: boolean = false;
  @Input() selectedItem: any;
  @Output() onSave = new EventEmitter();
  @Output() onHide = new EventEmitter();

  saveItem() {
    // Perform any validation or data-saving logic here

    // Emit an event to save the changes
    this.onSave.emit();

    // Hide the dialog
    this.hideDialog();
  }

  hideDialog() {
    // Reset the selectedItem
    this.selectedItem = {};

    // Emit an event to hide the dialog
    this.onHide.emit();
    this.hideDialog();
  }

  jsonData: any;
  validationError: string | null = null;

  ngOnInit () {

    this.jsonData = this.selectedItem.aggregation
  }

  validateJson() {
    try {
      JSON.parse(this.jsonData);
      this.validationError = null;
    } catch (error) {
      this.validationError = 'Invalid JSON format';
    }
  }

}
